<script>
  import Header from './Header.svelte';
  import TermsAndConditions from './TermsAndConditions.svelte';

  const logoUrl = 'logo.png'; // Replace with the correct path to your logo
</script>

<main>
  <Header logo={logoUrl} />
  <TermsAndConditions />
</main>
